"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastPlayerVolume = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const PodcastPlayerVolume = ({ audioRef, activeModal, setActiveModal, }) => {
    const [volume, setVolume] = React.useState(1);
    const containerRef = React.useRef(null);
    const [isDesktop, setIsDesktop] = React.useState(true);
    const volumeIcon = React.useMemo(() => {
        if (volume === 0)
            return 'volume-off';
        if (volume < 0.5)
            return 'volume-down';
        return 'volume-up';
    }, [volume]);
    const changeVolume = React.useCallback((newVolume) => {
        const audio = audioRef.current;
        const clampedVolume = Math.min(Math.max(newVolume, 0), 1);
        if (audio && clampedVolume !== volume) {
            audio.volume = clampedVolume;
            setVolume(clampedVolume);
        }
    }, [audioRef, volume]);
    const handleVolumeChange = (event) => {
        changeVolume(+event.target.value);
    };
    const handleVolumeButtonClick = (event) => {
        if (activeModal === 'volume') {
            setActiveModal(null);
        }
        else {
            setActiveModal('volume');
        }
    };
    React.useEffect(() => {
        var _a;
        const ua = (_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.userAgent;
        const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
        const isTablet = /iPad|Tablet/i.test(ua);
        const isIPadOnIPadOS = /Macintosh/i.test(ua) && 'ontouchend' in globalThis.document;
        const isMobileDevice = isMobile || isTablet || isIPadOnIPadOS;
        setIsDesktop(!isMobileDevice);
    }, []);
    if (!isDesktop) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { ref: containerRef, className: "podcast-player-volume relative", children: [(0, jsx_runtime_1.jsx)("button", { className: `podcast-player-volume__btn text-icon-primary  active:bg-fill-primary-pressed p-2xs flex h-10 w-10 items-center justify-center rounded-full ${activeModal === 'volume'
                    ? 'bg-fill-primary-pressed hover:bg-fill-primary-pressed'
                    : 'hover:bg-fill-primary-hovered'}  `, onClick: handleVolumeButtonClick, children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: volumeIcon }) }), activeModal === 'volume' && ((0, jsx_runtime_1.jsx)("div", { className: "podcast-player-volume__controller p-md bg-surface-primary -top-sm absolute flex h-[116px] w-[40px] translate-y-[-100%] items-center justify-center rounded-2xl shadow-md", children: (0, jsx_runtime_1.jsx)("input", { className: "podcast-player-volume__input h-[2px] w-[80px] origin-center rotate-[-90deg] cursor-pointer [appearance:none] [&::-moz-range-thumb]:mt-[-7px] [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-black [&::-moz-range-track]:h-[2px] [&::-moz-range-track]:bg-black [&::-webkit-slider-runnable-track]:h-[2px] [&::-webkit-slider-runnable-track]:bg-black [&::-webkit-slider-thumb]:relative [&::-webkit-slider-thumb]:top-1/2 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:translate-y-[-50%] [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-black", id: "volume-slider", type: "range", min: "0", max: "1", step: "0.01", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": volume, value: volume, onChange: handleVolumeChange }) }))] }));
};
exports.PodcastPlayerVolume = PodcastPlayerVolume;
